import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

const client = sanityClient({
  projectId: "ku616wfj", // Replace with your actual project ID
  dataset: "production", // Use the dataset you set up
  apiVersion: "2023-01-01", // Use the latest API version
  useCdn: true, // Use CDN for faster responses
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

export default client;
